const alt = require('components/alt');

class ZopimActions {
  onlineStatusUpdated(status) {
    return status;
  }
}

module.exports = alt.createActions(ZopimActions);



// WEBPACK FOOTER //
// ./javascripts/components/zopim/zopim_actions.js